import { useLocation, Navigate } from 'react-router-dom';
import { checkNavAccess } from '../utils/navGuardUtils';

export { NAV_BYPASS_PREFIXES, checkNavAccess } from '../utils/navGuardUtils';

const NavGuard = ({ permissions, userRole }) => {
	const location = useLocation();
	const allowed = checkNavAccess(location.pathname, permissions, userRole);
	return allowed ? null : <Navigate to="/dashboard" replace />;
};

export default NavGuard;